<script setup lang="ts">
import { BannerCallout } from "@/models/Banner";

const store = useBigHeroBannerStore();
const props = defineProps<{
  index: number;
  noTransition?: boolean;
}>();

const banner = computed(() => store.banners[props.index] as BannerCallout);

const emit = defineEmits<{
  (e: "load"): void;
}>();

function onLoad() {
  emit("load");
}
const internalLink = computed(
  () => /^\//.test(banner.value.url) || /^\.\.\//.test(banner.value.url),
);
</script>

<template>
  <BigHeroBannerSlide :index="index">
    <div class="slide">
      <BigHeroBannerBackgroundImg
        :img="banner.img"
        :first-image="index === 0"
        :no-lazy="true"
        :no-transition="noTransition"
        :alt="$t('SV.MES_CatholicChurchDescription')"
        @load="onLoad"
      />

      <div class="slide-container">
        <div class="slide-title my-1">
          {{ banner.text.title }}
        </div>
        <ul class="slide-items my-2">
          <li>
            <img
              :alt="$t('SV.LIT_BulletIcon', { title: banner.text.bullet1 })"
              :src="banner.text.bulletImg1"
            />{{ banner.text.bullet1 }}
          </li>
          <li>
            <img
              :alt="$t('SV.LIT_BulletIcon', { title: banner.text.bullet2 })"
              :src="banner.text.bulletImg2"
            />{{ banner.text.bullet2 }}
          </li>
          <li>
            <img
              :alt="$t('SV.LIT_BulletIcon', { title: banner.text.bullet3 })"
              :src="banner.text.bulletImg3"
            />{{ banner.text.bullet3 }}
          </li>
        </ul>
        <div class="slide-subtitle mt-2">
          {{ banner.text.subtitle }}
        </div>
        <div>
          <router-link
            v-if="internalLink"
            :to="banner.url"
            tabindex="-1"
            class="btn-purchase hero-banner-feature-button btn"
            :data-name="'CALLOUT: ' + banner.text.title"
          >
            {{ banner.text.cta }}
            <FAIcon
              aria-hidden="true"
              class="fa-light fa-chevron-right ms-1"
          /></router-link>
          <a
            v-else
            :href="banner.url"
            target="_blank"
            tabindex="-1"
            class="btn-purchase hero-banner-feature-button btn"
            :data-name="'CALLOUT: ' + banner.text.title"
          >
            {{ banner.text.cta }}
            <FAIcon
              aria-hidden="true"
              class="fa-light fa-chevron-right ms-1"
          /></a>
        </div>
      </div>
    </div>
  </BigHeroBannerSlide>
</template>

<style scoped lang="postcss"></style>
